
export default
  name: 'heats-table-simple'
  props: ['heats']
  data: ->
    event: general.event
    fields: [
      { key: 'bib', label: i18n.t('bib')},
      { key: 'name', label: i18n.t('name')},
      { key: 'race_id', label: i18n.t('activerecord.attributes.heat.race_id')},
      { key: 'category', label: i18n.t('category')},
      { key: 'status', label: i18n.t('status')},
      { key: 'result', label: i18n.t('result'), 'class': 'text-center font-weight-bold' },
      { key: 'ranks', label: i18n.t('rank'), class: 'text-center'},
    ],
  mounted: ->
    unless @event?
      @fields.splice(@fields.indexOf('race'), 1)

